<template>
  <span v-if="alladminrights">

    <li class="w3-cell-row" :key="businessindex" v-for="(businessadminright,businessindex) in alladminrights">
        <span>
            <business-info-layout :business="{name:`${businessadminright.name}` }">
                <span slot="headersideleft">                      
                      <i @click="refreshlist($event,businessindex)" class="fa fa-refresh w3-left" aria-hidden="true"></i>&nbsp;&nbsp;                      
                </span>
                <span slot="headersideright">
                      <open-close :ref="'openclose' + businessindex" @change="toggleMenu($event,businessindex)" :show=false class="w3-right"/>                      
                </span>
            </business-info-layout>                     
        </span>                
        <div  :id="businessindex + 'menu'"  style="display:none;border:none" >

            <table  class="w3-table-all">
              <tr class="w3-theme-l3" v-if="tempremedialslisting && tempremedialslisting[businessindex]==='loading'">
                <th>
                    Loading ......
                </th>                
              </tr>

              <tr v-if="tempremedialslisting && tempremedialslisting[businessindex] && tempremedialslisting[businessindex]!=='loading'">
                <th class="w3-hide-small">Unique Id</th>
                <th class="w3-hide-small">Type</th>
                <th>Job#</th>
                
                <th class="w3-hide-small">Status</th>
                <!-- <th class="w3-hide-small">Received</th> -->
                <!-- <th>Customer</th> -->
                <!-- <th class="w3-hide-small w3-hide-medium">Installer</th>   -->
                <th>issue</th>
                <th></th>
              </tr>              
              <template 
                v-if="tempremedialslisting && tempremedialslisting[businessindex] && tempremedialslisting[businessindex]!=='loading'"
                v-for="(remedial,index) in tempremedialslisting[businessindex]">
                <tr                    
                  :key="index"                    
                  :class="remedial.status | statustype('colour')">

                  <td class="w3-hide-small">{{remedial.shortid}}</td>
                  <td class="w3-hide-small">{{remedial.type | remedialtype}} {{remedial.linkedbusiness.name}}
                    <span v-if="remedial.Received"><br/>Received: ({{remedial.Received|formatDate}})</span>
                  </td>
                  <td>{{remedial.jobnumber||'-'}}</td>
                  
                  <td class="w3-hide-small">{{remedial.status | statustype('name')}}</td>        
                  <!-- <td class="w3-hide-small">{{remedial.Received|formatDate}}</td> -->
                  <!-- <td>{{remedial.GBContact}}</td> -->
                  <!-- <td class="w3-hide-small w3-hide-medium">{{remedial.Installer}}</td> -->
                  <td class="tooltip">                    
                      <i class="fa fa-sticky-note" aria-hidden="true"/>
                      <span class="tooltiptext">{{remedial.issue}}</span>
                  </td>
                  <td @click="$emit('remedialclick',{data:{business:{id:businessindex,name:businessadminright.name},remedial:{id:index}}})">                    
                     &#187;&#187;                    
                  </td>
                </tr>
                
                <!-- <tr :key="'issue' + index"
                  @click="$emit('remedialclick',{data:{business:{id:businessindex,name:businessadminright.name},remedial:{id:index}}})"
                  :class="parsestatus(remedial.status).colour">                  
                  <td class="w3-hide-small" colspan="7"><b>issue : </b><i>{{remedial.issue}}</i></td>                                    
                </tr> -->

              </template>
            </table>

          <br/>
        </div> 
    </li>   

  </span>
</template>

<script>
 import {
    mapGetters,
    mapActions
  } from "vuex";

  export default {
    props: ["alladminrights"],    
    name:'RemedialsTableLayout',
    data: function() {
      return {
        tempremedialslisting:{}         
      };
    },
    methods:{      
      ...mapActions(["businessremedials"]),     
      refreshlist(e,businessindex){     
            let temp = Object.assign({},this.tempremedialslisting)
            temp[businessindex] = 'loading'
            this.tempremedialslisting = temp 

            this.businessremedials({id:businessindex}).then((remedials)=>{                                              
              temp[businessindex] = remedials
              this.tempremedialslisting = temp            
            })          
      },        
      toggleMenu(e,businessindex) {    
            var menu = document.getElementById(`${businessindex}menu`);     
            if(menu)
                menu.style.display = e ? "block" : "none";
            if(e)
              this.refreshlist(e,businessindex)

      }
    },
    computed:{
      ...mapGetters(["templateconfig"]),
      
    }

  }
</script>
 
<style>
.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    left: 50%;
    margin-left: -60px;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/RemedialsTableLayout.vue